module.exports = "/lucky-balls/img/bigball/BigBall_018.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bigball/BigBall_018.png
// module id = 913
// module chunks = 0